module.exports = __webpack_public_path__ + "static/img/file_js.f0bc7e13.png";